import { initializeApp, getApps, type FirebaseApp, type FirebaseOptions } from 'firebase/app';
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics';

function env(name: string): string | undefined {
  const v = (process.env as Record<string, string | undefined>)[name];
  return v && v.trim().length > 0 ? v.trim() : undefined;
}

/** Web client config — set REACT_APP_FIREBASE_* in `.env` / `.env.production` (no hardcoded defaults). */
export function getFirebaseWebOptions(): FirebaseOptions {
  return {
    apiKey: env('REACT_APP_FIREBASE_API_KEY') ?? '',
    authDomain: env('REACT_APP_FIREBASE_AUTH_DOMAIN') ?? '',
    projectId: env('REACT_APP_FIREBASE_PROJECT_ID') ?? '',
    storageBucket: env('REACT_APP_FIREBASE_STORAGE_BUCKET') ?? '',
    messagingSenderId: env('REACT_APP_FIREBASE_MESSAGING_SENDER_ID') ?? '',
    appId: env('REACT_APP_FIREBASE_APP_ID') ?? '',
    measurementId: env('REACT_APP_FIREBASE_MEASUREMENT_ID'),
  };
}

export function getFirebaseVapidKey(): string | undefined {
  return env('REACT_APP_FIREBASE_VAPID_KEY');
}

let appInstance: FirebaseApp | null = null;

export function getFirebaseApp(): FirebaseApp | null {
  if (typeof window === 'undefined') return null;
  const opts = getFirebaseWebOptions();
  if (!opts.apiKey) return null;
  if (!appInstance) {
    appInstance = getApps().length ? getApps()[0]! : initializeApp(opts);
  }
  return appInstance;
}

let analyticsInitialized = false;

/** Safe no-op if analytics unsupported or no measurementId. */
export function initFirebaseAnalytics(): void {
  if (typeof window === 'undefined') return;
  const app = getFirebaseApp();
  if (!app) return;
  const opts = getFirebaseWebOptions();
  if (!opts.measurementId) return;
  void isAnalyticsSupported().then((ok) => {
    if (!ok || analyticsInitialized) return;
    analyticsInitialized = true;
    getAnalytics(app);
  });
}
